"use client";

import { createContext, useContext, useState, useEffect, ReactNode } from "react";
import { mockUser, mockCompany } from "./mock-data";

type User = typeof mockUser;
type Company = typeof mockCompany;

type AuthState = {
  user: User | null;
  company: Company | null;
  isAuthenticated: boolean;
  login: (email: string) => void;
  logout: () => void;
};

const AuthContext = createContext<AuthState>({
  user: null,
  company: null,
  isAuthenticated: false,
  login: () => {},
  logout: () => {},
});

export function AuthProvider({ children }: { children: ReactNode }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("shield_auth");
    if (stored === "true") setIsAuthenticated(true);
  }, []);

  function login(_email: string) {
    localStorage.setItem("shield_auth", "true");
    setIsAuthenticated(true);
  }

  function logout() {
    localStorage.removeItem("shield_auth");
    setIsAuthenticated(false);
  }

  return (
    <AuthContext.Provider
      value={{
        user: isAuthenticated ? mockUser : null,
        company: isAuthenticated ? mockCompany : null,
        isAuthenticated,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
